import { render, staticRenderFns } from "./home_right.vue?vue&type=template&id=b72f56a0&scoped=true"
import script from "./home_right.vue?vue&type=script&lang=js"
export * from "./home_right.vue?vue&type=script&lang=js"
import style0 from "./home_right.vue?vue&type=style&index=0&id=b72f56a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f56a0",
  null
  
)

export default component.exports